import { render, staticRenderFns } from "./FormDinamicos.vue?vue&type=template&id=35b6eb6a"
import script from "./FormDinamicos.vue?vue&type=script&lang=js"
export * from "./FormDinamicos.vue?vue&type=script&lang=js"
import style0 from "./FormDinamicos.vue?vue&type=style&index=0&id=35b6eb6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports